import { createTheme } from "@mui/material/styles";

// Colours from the original site - orange, dark orange and charcoal text on white
const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#C3771D",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fff",
      contrastText: "#4D4B4B",
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      primary: "#4D4B4B",
      secondary: "#6b6868",
    },
  },
  shape: {
    borderRadius: 0,
  },
  typography: {
    fontFamily: "Barlow, \"Helvetica Neue\", Helvetica, Arial, sans-serif",
    button: {
      fontFamily: "Arimo, \"Helvetica Neue\", Helvetica, Arial, sans-serif",
      textTransform: "none",
      fontSize: "0.95rem",
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "10px 30px",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
  },
});

export default theme;
